import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useDatingRequestCount(userId?: string) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!userId) return;

    const load = async () => {
      const [incomingRes, mySwipesRes, myMatchesRes] = await Promise.all([
        supabase.from('swipes').select('swiper_id').eq('swiped_id', userId).eq('direction', 'like'),
        supabase.from('swipes').select('swiped_id').eq('swiper_id', userId),
        supabase.from('matches').select('user1_id, user2_id').or(`user1_id.eq.${userId},user2_id.eq.${userId}`),
      ]);

      const incomingLikes = incomingRes.data ?? [];
      const mySwipedIds = new Set((mySwipesRes.data ?? []).map((s: any) => s.swiped_id));
      const matchedIds = new Set((myMatchesRes.data ?? []).map((m: any) => m.user1_id === userId ? m.user2_id : m.user1_id));

      const pending = incomingLikes.filter((l: any) => !mySwipedIds.has(l.swiper_id) && !matchedIds.has(l.swiper_id));
      if (pending.length === 0) {
        setCount(0);
        return;
      }

      const requestUserIds = pending.map((l: any) => l.swiper_id);
      const { data: profiles } = await supabase
        .from('profiles')
        .select('user_id, dating_enabled')
        .in('user_id', requestUserIds);

      const enabledIds = new Set((profiles ?? []).filter((p: any) => p.dating_enabled === true).map((p: any) => p.user_id));
      const realRequestCount = pending.filter((l: any) => enabledIds.has(l.swiper_id)).length;

      const excludeIds = [...mySwipedIds, ...matchedIds, ...requestUserIds, userId];
      const { data: aiProfiles } = await supabase
        .from('profiles')
        .select('user_id')
        .eq('chatbot_enabled', true)
        .eq('dating_enabled', true)
        .not('user_id', 'in', `(${excludeIds.join(',')})`)
        .limit(5);

      setCount(realRequestCount + (aiProfiles?.length ?? 0));
    };

    load();
  }, [userId]);

  return count;
}
